import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'

import Button from './Button'
import Dialog from './Dialog'
import InputField from './InputField'
import GridCircularProgress from './GridCircularProgress'
import {
  titlesIscrizioni as titles,
  phrasesIscrizioni as phrases,
} from '../settings/settings'
import { useFeedback } from '../hooks/feedback-hook'
import {
  useUpdateCalendarioIndirizzoMutation,
  useGetIscrizioneByIdQuery,
} from '../hooks/api-slice'
import {
  formatIndirizzo,
  linkToGoogleMaps,
  formatBodyField,
  isObjectId,
  useIndirizzoGara,
} from '../hooks/utils-functions'

const DialogIndirizzo = ({ open, handleClose, gara }) => {
  const { admin } = useSelector(state => state.home.infoUtente)

  const { isFetching: isFetchingInd } = useGetIscrizioneByIdQuery(
    gara?.squadraCasaID,
    { skip: !isObjectId(gara?.squadraCasaID) },
  )

  const [updateCalendarioIndirizzo] = useUpdateCalendarioIndirizzoMutation()

  const [loading, setLoading] = useState()
  const [presso, setPresso] = useState('')
  const [indirizzo, setIndirizzo] = useState('')
  const [citta, setCitta] = useState('')
  const [newIndirizzo, setNewIndirizzo] = useState()

  const fIndirizzo = useIndirizzoGara(gara)

  const { setFeedback } = useFeedback()

  const resetIndirizzo = () => {
    setPresso('')
    setIndirizzo('')
    setCitta('')
  }

  const updateIndirizzo = async (id, presso, indirizzo, citta) => {
    const arg = { id, presso, indirizzo, citta }
    const result = await updateCalendarioIndirizzo(arg)
    if (!result?.error) {
      setFeedback(phrases.phrasesIndirizzoSuccess, false, titles.titleIndirizzo)
      resetIndirizzo()
    }
  }

  useEffect(() => {
    setNewIndirizzo(formatIndirizzo({ presso, indirizzo, citta }))
  }, [presso, indirizzo, citta])

  useEffect(() => {
    resetIndirizzo()
  }, [open])

  return (
    <Dialog open={open} handleClose={handleClose} title='Campo di gioco'>
      {(isFetchingInd && <GridCircularProgress />) ||
        (!gara && 'Nessuna partita selezionata.') || (
          <Grid container spacing={5} sx={{ width: '100%' }}>
            {(!fIndirizzo && <i>Indirizzo non trovato.</i>) || (
              <Grid container spacing={2} sx={{ width: '100%' }}>
                <Grid size={12}>
                  <b>{fIndirizzo}</b>
                </Grid>
                <Grid size={12}>{linkToGoogleMaps(fIndirizzo)}</Grid>
              </Grid>
            )}
            {admin && (
              <Grid container spacing={2} sx={{ width: '100%' }}>
                <Grid size={12}>
                  <b>Aggiorna indirizzo</b>
                </Grid>
                <Grid size={12}>
                  <InputField
                    id='presso'
                    value={presso}
                    onChange={i => setPresso(formatBodyField(i, 'upper'))}
                    label='Istituto o centro sportivo'
                    adornment='place'
                  />
                </Grid>
                <Grid size={12}>
                  <InputField
                    id='indirizzo'
                    value={indirizzo}
                    onChange={i => setIndirizzo(formatBodyField(i, 'upper'))}
                    label='Indirizzo'
                    adornment='zone'
                  />
                </Grid>
                <Grid size={12}>
                  <InputField
                    id='città'
                    value={citta}
                    onChange={i => setCitta(formatBodyField(i, 'upper'))}
                    label='Città'
                    adornment='city'
                  />
                </Grid>
                {newIndirizzo && (
                  <Grid size={12}>{linkToGoogleMaps(newIndirizzo)}</Grid>
                )}
                <Grid size={12}>
                  <center>
                    <Button
                      loading={loading}
                      onClick={async () => {
                        setLoading(true)
                        await updateIndirizzo(
                          gara?._id,
                          presso,
                          indirizzo,
                          citta,
                        )
                        setLoading()
                      }}
                    >
                      Aggiorna
                    </Button>
                  </center>
                </Grid>
              </Grid>
            )}
          </Grid>
        )}
    </Dialog>
  )
}

export default DialogIndirizzo
